import React from 'react';
import { painPoints } from '../data/content';
export function Problem() {
  return <section className="w-full bg-cream" data-id="element-187" data-mp="2pf8pw8d587n0">
      <div className="mx-auto max-w-content px-5 py-16 lg:px-8 lg:py-24" data-id="element-188" data-mp="2pe7fm63ybp6c">
        <div className="grid gap-12 lg:grid-cols-[1fr_1.1fr] lg:gap-20" data-id="element-189" data-mp="2bgisssqbq7yn">
          <div data-id="element-190" data-mp="2gesmt00bb2io">
            <h2 className="font-display text-3xl font-black leading-tight text-ink sm:text-4xl" data-id="element-191" data-mp="2geauufkonagk">
              El problema no siempre es cuánto ganás.
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-ink-muted" data-id="element-192" data-mp="21o3blxmupnet">
              Muchas veces el verdadero problema es no tener un sistema sencillo
              para decidir qué hacer con el dinero{' '}
              <span className="font-semibold text-ink" data-id="element-193" data-mp="1wqtd7shhi1eu">antes</span> de gastarlo.
            </p>
            <p className="mt-4 text-lg leading-relaxed text-ink-muted" data-id="element-194" data-mp="1woh13vyeql9p">
              Sin ese sistema, todos los meses arrancan igual: cobrás, pagás lo
              urgente y el resto se va sin decisión.
            </p>
          </div>

          <ul className="divide-y divide-line border-y border-line" data-id="element-195" data-mp="t95j0u18c0sx">
            {painPoints.map(point => <li key={point} className="flex items-start gap-4 py-4 text-base text-ink" data-id="element-196" data-mp="obn84y3njbia">
                <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-alert" aria-hidden="true" data-id="element-197" data-mp="12b4znl8c12vc" />
                {point}
              </li>)}
          </ul>
        </div>

        <p className="mt-14 max-w-3xl font-display text-2xl font-extrabold leading-snug text-forest sm:text-3xl" data-id="element-198" data-mp="x9pc9miomk9s">
          No necesitás ganar el doble. Necesitás saber qué hacer con lo que ya
          entra.
        </p>
      </div>
    </section>;
}